fragment GoPayDataFull on GoPayData {
  id
  state
  paymentType
  url
  amount
  processedAt
  refundedAmount
}
